import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, CircularProgress, CssBaseline, Dialog, Typography } from "@mui/material";
import Header from "../components/shared/header";
import Dashboard from "../components/shared/dashboard/dashboard";
import MedicationsAllergies from "../components/patient_profile/medications_allergies";
import CareTeamRecords from "../components/patient_profile/care_team_records";
import VideoList from "../components/patient_profile/video_list";
import SleepDiary from "../components/patient_profile/sleep_diary";
import HealthDiary from "../components/patient_profile/health_diary";
import MetaDecorator from "../services/meta_decorator";
import MyCareJourney from "./my_care_journey";
import Newsidebar from "../components/shared/newsidebar";
import Newheader from "../components/shared/newheader";
import { Grid, ListItem, ListItemButton } from "@mui/material";
import Footer from "../components/shared/footer";
import JournalAction from "../components/patient_profile/journalaction";
import HealthTracker from "../components/patient_profile/healthtracker";
import AccessLocalStorage from "../services/localStorage";
import dayjs from "dayjs";
import InactivityMeter from "../components/shared/inactivitymeter";
import CloseIcon from '@mui/icons-material/Close';
import { getApiUrl } from "../services/api_service";
import { saveAs } from 'file-saver';
import { useSelector } from "react-redux";
import SeizureDiary from "../components/patient_profile/seizure_diary";
import { FormsList } from "../components/patient_profile/forms_list";
import { bodyBg2, buttonRed, dashboardText, epilepsyHeading2, healthProfileLinkDashboard, homeImageMainOpen, lightcolor, mainGrid, paddingbox, pcolor, pointer, primaryColor, rcolor, scrollMargin } from "../style2";
import { AISummaryList } from "../components/shared/aisummarylist";
import { EpilepsyPathwayName, NDPathwayName } from "../services/utility";


function Patient_Profile() {
  const history = useHistory();
  const [newJournalCreateTime, setNewJournalCreateTime] = useState(null);
  const [showDownloadProfilePopup, setShowDownloadProfilePopup] = useState(false);
  const [loadingDownloadData, setLoadingDownloadData] = useState(false);
  const [errorDownloadData, setErrorDownloadData] = useState('');
  const [successDownloadData, setSuccessDownloadData] = useState('');
  //const classes = useStyles();
  const ls = new AccessLocalStorage();

  const [taster, setTaster] = useState(null);
  const [loadingTaster, setLoadingTaster] = useState(false);
  const [errorTaster, setErrorTaster] = useState('');

  const [patientuser, setPatientuser] = useState(null);
  const [loadingPatientuser, setLoadingPatientuser] = useState(false);
  const [errorPatientuser, setErrorPatientuser] = useState('');

  const patient = useSelector((state) => state.patient.value);
  const pediatricianbuttons = [
    { label: "Tracker", targetId: "healthtracker", icon: null, src: "assets/date.png" },
    { label: "Health Diary", targetId: "healthdiary-section", icon: null, src: "assets/diary.png" },
    { label: "Sleep Diary", targetId: "sleepdiary-section", icon: null, src: "assets/sleep-diary.png" },
    { label: "Videos", targetId: "video-section", icon: null, src: "assets/video.png" },
    { label: "Records", targetId: "records-section", icon: null, src: "assets/patient.png" },
    { label: "Forms", targetId: "forms-section", icon: null, src: "assets/forms.png" },
    { label: "Care Team", targetId: "care-team-section", icon: null, src: "assets/primary-care.png" },
    { label: "Care Journey", targetId: "mycarejourney", icon: null, src: "assets/medical-journey.png" },
    { label: <>Medication &<br /> Allergies</>, targetId: "medications-and-allergies-section", icon: null, src: "assets/medicine.png" },].map((button, index) => (
      <Box sx={{ paddingBottom: "15px", paddingTop: "10px" }}>
        <ListItemButton
          key={index}
          onClick={() => handleScroll(button.targetId)}
          sx={{ width: '100%', justifyContent: 'center' }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            sx={{
              width: 'auto', // don’t force 100%
              minWidth: 40,  // ensures icon space
              color: "rgba(0, 0, 0, 0.6)",
            }}
          >
            {button.src !== "" ? (
              <Box component="img"
                src={button.src}
                alt={button.label}
                title={button.label}
                sx={{
                  width: "34px",
                  height: "34px",
                  flexShrink: 0, // prevents shrinking
                  ...homeImageMainOpen
                }}
              />
            ) : (
              button.icon
            )}
            {button.label !== "" && (
              <Typography
                variant="caption"
                sx={{
                  textAlign: "center",
                  paddingTop: 0.5,
                  display: { xs: "none", md: "block" }, // hide labels when collapsed if desired
                }}
              >
                {button.label}
              </Typography>
            )}
          </Box>
        </ListItemButton>
      </Box>
    ));
  const teacherbuttons = [
    { label: "Care Journey", targetId: "mycarejourney", icon: null, src: "assets/medical-journey.png" },
    { label: <>Medication &<br /> Allergies</>, targetId: "medications-and-allergies-section", icon: null, src: "assets/medicine.png" },
    { label: "Health Diary", targetId: "healthdiary-section", icon: null, src: "assets/diary.png" },
    { label: "Records", targetId: "records-section", icon: null, src: "assets/patient.png" },
    { label: "Care Team", targetId: "care-team-section", icon: null, src: "assets/primary-care.png" },
  ].map((button, index) => (
    <Box sx={{ paddingBottom: "15px", paddingTop: "10px" }}>
      <ListItemButton
        key={index}
        onClick={() => handleScroll(button.targetId)}
        style={{ width: '100%', justifyContent: 'center' }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 'auto', // don’t force 100%
            minWidth: 40,  // ensures icon space
            color: "rgba(0, 0, 0, 0.6)",
          }}
        >
          {button.src !== "" ? (
            <Box component="img"
              src={button.src}
              alt={button.label}
              title={button.label}
              sx={{
                width: "34px",
                height: "34px",
                flexShrink: 0, // prevents shrinking
                ...homeImageMainOpen
              }}
            />
          ) : (
            button.icon
          )}
          {button.label !== "" && (
            <Typography
              variant="caption"
              sx={{
                textAlign: "center",
                paddingTop: 0.5,
                display: { xs: "none", md: "block" }, // hide labels when collapsed if desired
              }}
            >
              {button.label}
            </Typography>
          )}
        </Box>
      </ListItemButton>
    </Box>
  ));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      return;
    }

    setLoadingPatientuser(true);
    setErrorPatientuser('');
    fetch(
      `${getApiUrl()}/patientuser/${ls.getCurrentPatientId()}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          response.json().then(data => {
            console.log("Patient data:", data);
            setPatientuser(data);
          }).catch((err) => {
            setErrorPatientuser('Unable to load patient data.');
            console.log(err);
          });
        } else {
          setErrorPatientuser('Unable to load patient data.');
        }
      })
      .catch((err) => {
        setErrorPatientuser('Unable to load patient data.');
        console.log(err);
      })
      .finally(() => { setLoadingPatientuser(false); });
  }, []);

  const hasPathway = (pathwayName) => {
    if (!patientuser?.pathways || !Array.isArray(patientuser.pathways)) return false;
    return patientuser.pathways.some(
      (p) => p.name?.toLowerCase() === pathwayName?.toLowerCase()
    );
  };

  const getPathway = (pathwayName) => {
    if (!patientuser?.pathways || !Array.isArray(patientuser.pathways)) return null;
    return patientuser.pathways.find(
      (p) => p.name?.toLowerCase() === pathwayName?.toLowerCase()
    ) ?? null;
  };

  const handleScroll = (targetId) => {

    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleViewEpilepsyDashboard = useCallback(
    () => history.push("/epilepsy_dashboard"),
    [history]
  );

  const handleHPPersonalOnClick = useCallback(
    () => history.push("/health_profile#0"),
    [history]
  );
  const handleHPClinicalOnClick = useCallback(
    () => history.push("/health_profile#1"),
    [history]
  );
  const handleHPEducationOnClick = useCallback(
    () => history.push("/health_profile#2"),
    [history]
  );

  const closeDownloadDataPopup = () => {
    setErrorDownloadData(''); setSuccessDownloadData(''); setShowDownloadProfilePopup(false);
  }

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      return;
    }

    setLoadingTaster(true);
    setErrorTaster('');
    let error = 'Unable to load epilepsy information.';
    fetch(
      `${getApiUrl()}/seizurediary/taster/${ls.getCurrentPatientId()}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          response.json().then(data => {
            setTaster(data);
          }).catch((err) => {
            setErrorTaster(error);
            console.log(err);
          });
        } else {
          setErrorTaster(error);
        }
      })
      .catch((err) => {
        setErrorTaster(error);
        console.log(err);
      })
      .finally(() => { setLoadingTaster(false); });
  }, []);

  const downloadDataFromServer = () => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      return;
    }
    setLoadingDownloadData(true);
    setErrorDownloadData('');
    setSuccessDownloadData('');
    fetch(
      `${getApiUrl()}/profile/downloadpatientdata/${ls.getCurrentPatientId()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          let filename = `${patient.user.firstName} ${patient.user.surname}.docx`;
          response.blob().then(blob => {
            saveAs(blob, filename);
            setSuccessDownloadData('success');
            setTimeout(() => { closeDownloadDataPopup(); }, 2000);
          });
        } else {
          response.json().then(data => {
            setErrorDownloadData(`Unable to download data. ${data.error}`);
          }).catch(err => {
            console.log(err);
            setErrorDownloadData("Unable to download data.");
          })
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => { setLoadingDownloadData(false); });
  }

  const renderShowDownloadPopup = () => {
    if (showDownloadProfilePopup) {
      return (<Dialog open={true} maxWidth="xs" fullWidth>
        <Grid container xs={12} sx={{ border: `1px solid ${rcolor}`, borderRadius: "5px", backgroundColor: lightcolor }}>
          <Grid container item xs={12} sx={{ padding: "10px" }}>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} sx={{ textAlign: "center" }}>
              <Typography sx={{ color: pcolor, fontWeight: "bold", fontSize: "20px", textTransform: "capitalize" }}>Confirm Action</Typography>
            </Grid>
            <Grid item xs={1} >
              <CloseIcon onClick={() => { closeDownloadDataPopup(); }} sx={{ ...pointer, color: rcolor, fontSize: "1.5rem" }} />
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ padding: "0px 20px 30px 20px", textAlign: "center" }}>
            <Typography sx={{ paddingBottom: 2, fontSize: "0.9rem" }}>The report contains the following data.</Typography>
            <ul>
              <li style={{ fontSize: "0.9rem", textAlign: "left" }}>Health profile including personal, clinical and educational information.</li>
              <li style={{ fontSize: "0.9rem", textAlign: "left" }}>Symptom presentation (indicators) captured over the past 3 months.</li>
            </ul>
            {errorDownloadData !== '' ? <Typography style={{ color: "red", padding: 2 }}>{errorDownloadData}</Typography> : null}
            {successDownloadData === 'success' ? <>
              <Typography sx={{ fontWeight: "bold", color: "green", fontSize: "1.1rem" }}>Report successfully downloaded</Typography>
              <Box sx={{ fontSize: "0.9rem", paddingBottom: 3, paddingTop: 3 }}><Typography >Check your <strong>Downloads</strong> folder.</Typography></Box>
            </> : null}
            {loadingDownloadData ? <CircularProgress size="30px" /> : <Button disabled={loadingDownloadData}
              onClick={() => { downloadDataFromServer(); }} sx={{ width: "200px", ...buttonRed }}>Download</Button>}
          </Grid>
        </Grid>
      </Dialog>)
    }
    return null;
  }


  return (
    <Box sx={bodyBg2}>
      <CssBaseline />
      <MetaDecorator title={"EnrichMyCare - Patient Profile"} description={"Professional dashboard app"} />
      <Newsidebar selected='home' buttons={ls.isAdmin() || ls.isPediatrician() ? pediatricianbuttons : ls.isTeacher() ? teacherbuttons : teacherbuttons} />
      <Newheader show_profile_button={true} show_back_button={true} />
      <Box id="topofpage" sx={scrollMargin}></Box>
      <Header show_welcome_message={false} show_back_button={true} show_profile_button={false} />
      <Dashboard profile_image={true} detail_text={true} share_icons={false} end_card={true} cards={true} health_profile_button={true} />

      {!loadingPatientuser ? <>
        <Box m={1} />
        {(ls.isPediatrician() && hasPathway(NDPathwayName)) || ls.isAdmin() ? <AISummaryList pathway={getPathway(NDPathwayName)} /> : null}
        {(ls.isPediatrician() && hasPathway(EpilepsyPathwayName)) || ls.isAdmin() ? <AISummaryList pathway={getPathway(EpilepsyPathwayName)} /> : null}
        <Box mb={2} />
        {(ls.isPediatrician() && hasPathway(EpilepsyPathwayName)) || ls.isAdmin() ? <>
          <Box sx={paddingbox}>
            <Grid container>
              <Grid item xs={6}>
                <Box display="flex" alignItems="center" sx={dashboardText} >
                  <Typography sx={dashboardText} variant="h6" component="div" marginLeft={1}>
                    Epilepsy Dashboard
                  </Typography>
                </Box>
                <Box m={2} />
              </Grid>
              <Grid item xs={6} style={{ textAlign: "right" }}>
                {ls.isPediatrician() || ls.isAdmin() ? <Button disabled={loadingTaster} sx={{ padding: "6px 16px", marginLeft: "10px", ...buttonRed }}
                  onClick={handleViewEpilepsyDashboard}>View</Button>
                  : null}
              </Grid>
              <Grid item xs={12}>
                {loadingTaster ? <Box display="flex" justifyContent="center" alignItems="center" height="150px" sx={mainGrid}>
                  <CircularProgress />
                </Box> : null}
                {errorTaster !== '' ? <Box display="flex" justifyContent="center" alignItems="center" height="150px" sx={mainGrid}>
                  <Typography style={{ color: "red" }}>{errorTaster}</Typography>
                </Box> : null}
                {!loadingTaster && taster != null ?
                  <Box sx={mainGrid}>
                    <Typography component="div" sx={{ ...epilepsyHeading2, ...primaryColor }} >{taster.dateRangeDisplay}</Typography>
                    <Grid container >
                      <Grid item md={6} lg={3} xs={12} p={2}>
                        <Box bgcolor="#fff" p={1} sx={{ borderRadius: "5px", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                          <Typography fontWeight="bold" component="div" sx={{ ...epilepsyHeading2, ...primaryColor }}>
                            Total Seizures
                          </Typography>
                          <Typography fontWeight="bold" variant="h1" component="div"
                            style={{
                              textAlign: "center", flexGrow: 1, padding: "10px", display: "flex",
                              alignItems: "center", justifyContent: "center"
                            }}
                            sx={primaryColor}>

                            {taster.totalSeizures}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={6} lg={3} xs={12} p={2}>
                        <Box bgcolor="#fff" p={1} sx={{ borderRadius: "5px" }}>
                          <Typography fontWeight="bold" component="div" sx={{ ...epilepsyHeading2, ...primaryColor }}>
                            Length of Seizure
                          </Typography>
                          <Box m={1}></Box>
                          <Box p={1} style={{ display: "flex", backgroundColor: "#D4EEEA", fontSize: "17px", color: "#16757A", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                            <span style={{ flexGrow: 1 }}>&lt; 1 min</span>
                            <span style={{ padding: "0px 5px" }}>{taster.totalLOSOneMin}</span>
                          </Box>
                          <Box m={1}></Box>
                          <Box p={1} style={{ display: "flex", backgroundColor: "#16757A", fontSize: "17px", color: "#ffffff", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                            <span style={{ flexGrow: 1 }}> 1-5 min</span>
                            <span style={{ padding: "0px 5px" }}>{taster.totalLOSOneToFiveMin}</span>
                          </Box>
                          <Box m={1}></Box>
                          <Box p={1} style={{ display: "flex", backgroundColor: "#FED086", fontSize: "17px", color: "#16757A", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                            <span style={{ flexGrow: 1 }}> 5-10 min</span>
                            <span style={{ padding: "0px 5px" }}>{taster.totalLOSFiveToTenMin}</span>
                          </Box>
                          <Box m={1}></Box>
                          <Box p={1} style={{ display: "flex", backgroundColor: "#E7585D", fontSize: "17px", color: "#ffffff", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                            <span style={{ flexGrow: 1 }}> &ge; 10 min</span>
                            <span style={{ padding: "0px 5px" }}>{taster.totalLOSMoreThanTenMin}</span>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item md={6} lg={3} xs={12} p={2}>
                        <Box bgcolor="#fff" p={1} sx={{ borderRadius: "5px", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                          <Typography fontWeight="bold" component="div" sx={{ ...epilepsyHeading2, ...primaryColor }}>
                            Rescue Medication
                          </Typography>
                          <Typography fontWeight="bold" variant="h1" component="div"
                            style={{
                              textAlign: "center", flexGrow: 1, padding: "10px", display: "flex",
                              alignItems: "center", justifyContent: "center"
                            }}
                            sx={primaryColor}>
                            <Box style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
                              <Typography component="span" fontWeight="bold" style={{ fontSize: "5rem" }}>{taster.totalRescueMedications}</Typography>
                              <Typography component="span" style={{ fontSize: "14px", paddingLeft: "5px" }}>times</Typography>
                            </Box>

                          </Typography>

                        </Box>
                      </Grid>
                      <Grid item md={6} lg={3} xs={12} p={2}>
                        <Box bgcolor="#fff" p={1} sx={{ borderRadius: "5px" }}>
                          <Typography fontWeight="bold" component="div" sx={{ ...epilepsyHeading2, ...primaryColor }}>
                            Recovery
                          </Typography>
                          <Box m={1}></Box>
                          <Box p={1} style={{ display: "flex", fontSize: "17px", color: "#16757A", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                            <span style={{ flexGrow: 1 }}>&lt; 1 min</span>
                            <span style={{ padding: "0px 5px" }}>{taster.recovery.LessThan1Minute}</span>
                          </Box>
                          <Box m={1}></Box>
                          <Box p={1} style={{ display: "flex", color: "#16757A", fontSize: "17px", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                            <span style={{ flexGrow: 1 }}> &lt; 10 mins</span>
                            <span style={{ padding: "0px 5px" }}>{taster.recovery.LessThan10Minutes}</span>
                          </Box>
                          <Box m={1}></Box>
                          <Box p={1} style={{ display: "flex", fontSize: "17px", color: "#16757A", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                            <span style={{ flexGrow: 1 }}> &gt; 10 mins</span>
                            <span style={{ padding: "0px 5px" }}>{taster.recovery.MoreThan10Minutes}</span>
                          </Box>
                          <Box m={1}></Box>
                          <Box p={1} style={{ display: "flex", fontSize: "17px", color: "#16757A", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                            <span style={{ flexGrow: 1 }}> Slept</span>
                            <span style={{ padding: "0px 5px" }}>{taster.recovery.Slept}</span>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box> : null}
              </Grid>
            </Grid>
          </Box>
          <Box m={1} />
        </> : null}
        <Box sx={paddingbox}>
          <Grid container>
            <Grid item xs={6}>
              <Box display="flex" alignItems="center" sx={dashboardText} >
                <Typography sx={dashboardText} variant="h6" component="div" marginLeft={1}>
                  Health Profile
                </Typography>
              </Box>
              <Box m={2} />
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {ls.isPediatrician() || ls.isAdmin() ?
                <><Button sx={{ width: 180, ...buttonRed }} onClick={() => { setShowDownloadProfilePopup(true); }}>Download Report</Button>
                  {renderShowDownloadPopup()}</> : null}

            </Grid>
            <Grid item xs={12}>
              <Grid container sx={mainGrid}>
                <Grid item xs={12} md={4} mb={1} p={1}>
                  <Box sx={{ ...healthProfileLinkDashboard, ...pointer }} onClick={handleHPPersonalOnClick}>
                    Personal/Family/Social
                  </Box>
                </Grid>
                <Grid item xs={12} md={4} mb={1} p={1}>
                  <Box sx={{ ...healthProfileLinkDashboard, ...pointer }} onClick={handleHPClinicalOnClick}>
                    Background/Milestones
                  </Box>
                </Grid>
                <Grid item xs={12} md={4} mb={1} p={1}>
                  <Box sx={{ ...healthProfileLinkDashboard, ...pointer }} onClick={handleHPEducationOnClick}>
                    Education/Special needs
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        {ls.isPediatrician() || ls.isAdmin() ? <>
          <Box id="healthtracker" sx={scrollMargin} mb={2}></Box>
          <HealthTracker newJournalCreatedTime={newJournalCreateTime} />
          <Box id="healthdiary-section" sx={scrollMargin} mb={2}></Box>
          <HealthDiary newJournalCreatedTime={newJournalCreateTime} />
          <Box id="sleepdiary-section" sx={scrollMargin} mb={2}></Box>
          <SleepDiary />
          <Box id="seizurediary-section" sx={scrollMargin} mb={2}></Box>
          <SeizureDiary />
          <Box id="video-section" sx={scrollMargin} mb={2}></Box>
          <VideoList />
          <CareTeamRecords id={["care-team-section", "records-section"]} />
          <Box id="forms-section" sx={scrollMargin} mb={2}></Box>
          <FormsList />
          <Box id="mycarejourney" sx={scrollMargin} mb={2}></Box>
          <MyCareJourney />
          <Box id="medications-and-allergies-section" sx={scrollMargin} mb={2}></Box>
          <MedicationsAllergies />

        </> : ls.isTeacher() ? <>
          <Box id="mycarejourney" sx={scrollMargin} mb={2}></Box>
          <MyCareJourney />
          <Box id="medications-and-allergies-section" sx={scrollMargin} mb={2}></Box>
          <MedicationsAllergies />
          <Box id="healthdiary-section" sx={scrollMargin} mb={2}></Box>
          <HealthDiary newJournalCreatedTime={newJournalCreateTime} />
          <Box id="seizurediary-section" sx={scrollMargin} mb={2}></Box>
          <SeizureDiary />
          <CareTeamRecords id={["care-team-section", "records-section"]} />
        </> : <>
          <Box id="mycarejourney" sx={scrollMargin} mb={2}></Box>
          <MyCareJourney />
          <Box id="medications-and-allergies-section" sx={scrollMargin} mb={2}></Box>
          <MedicationsAllergies />
          <Box id="healthdiary-section" sx={scrollMargin} mb={2}></Box>
          <HealthDiary newJournalCreatedTime={newJournalCreateTime} />
          <CareTeamRecords id={["care-team-section", "records-section"]} />
        </>}
      </> : <Box sx={{ ...paddingbox, minHeight: "500px", display: "flex", alignItems: "start", justifyContent:"center", gap: 1 }}>
        <CircularProgress size={20} /><Typography>Please wait while patient dashboard is loading.</Typography>
        </Box>}

      <JournalAction onJournalCreated={() => { setNewJournalCreateTime(dayjs()) }} />
      <InactivityMeter />
      <Box style={{ width: "100%", textAlign: "center", marginTop: "20px" }}>
        <Footer />
      </Box>
    </Box>
  );
}

export default Patient_Profile;
